import Api from './axiosInstance'
import { API_USER_MGMT } from 'utils/constants'

const { USER, UPDATE_COLS } = API_USER_MGMT

export type TableConfig = {
  pricing?: string[]
  inventory?: string[]
  master?: string[]
}

// To Register a user in DB
const createUser = (data: any) => {
  return Api.post({ url: USER, data: data })
}

// To get all users from DB
const getAllUsers = ({
  limit,
  page,
  search,
}: {
  limit: number
  page: number
  search?: string
}) => {
  const options: any = {}

  if (search) {
    options.search = search
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${USER}?${params}`,
  })
}

// To get user from DB using ID
const getUser = (id: string) => {
  return Api.get({
    url: `${USER}/${id}`,
  })
}

// To update user in DB using ID
const updateUser = ({ id, data }: { id: string; data: any }) => {
  return Api.patch({
    url: `${USER}/${id}`,
    data,
  })
}

// To update the user specific columns
const updateTableCols = (data: TableConfig) => {
  return Api.patch({
    url: UPDATE_COLS,
    data,
  })
}

export { createUser, getAllUsers, getUser, updateUser, updateTableCols }
